import history from './history'

const navigateTo = ({ to, replace = false }) => {
  if (typeof to !== 'string') throw new Error(`Nav 'to' argument should be of type string`);
  
  if (replace) {
    return history.replace(to); 
  } else {
    return history.push(to);   
  }
} // END navigateTo

export default navigateTo

export const sendTo = (obj) => {
  return history.push(obj);

} // END sendTo


// WEBPACK FOOTER //
// ./src/app/navigateTo.js